export const snakify = src => {
  // log('Input object', o);
  var o = Object.assign({}, src)
  for (var key of Object.keys(o)) {
    var value = o[key]
    // log(`stashing away ${key} - ${value}`);
    var currentKey = key
    // log('checking: ' + currentKey + ' with ' + value);
    while (true) {
      const found = currentKey.match(/^([a-z_]+)([A-Z][a-z]+)([A-Z][a-z]+)?/)
      if (!found) {
        /* istanbul ignore next */
        if (currentKey === 'imageURL') {
          o[currentKey] = undefined
          o['image_URL'] = value
        } else if (currentKey === 'TZOffset') {
          o[currentKey] = undefined
          o['TZ_offset'] = value
        }
        break
      } else {
        // log('processing: ' + currentKey + ' with ' + value);
        o[currentKey] = undefined
        var camel = found[2]
        /* istanbul ignore next */
        if (camel !== 'URL') {
          camel = camel.toLowerCase()
        }
        var suffix = found[3]
        if (!suffix) {
          suffix = ''
        }
        currentKey = found[1] + '_' + camel + suffix
        // log(`Reassigning ${currentKey} to ${value}`);
        o[currentKey] = value
      }
    }
  }
  // log("snake_case results", o);
  return o
}
